// extracted by mini-css-extract-plugin
module.exports = {"logOverview":"styles_logOverview__E2DIy","containerOverviewLog":"styles_containerOverviewLog__1udwA","logSummary":"styles_logSummary__4z_Hr"};